// Warm only the exact native Color photo; native product updates still own display.
const pickerSelector = 'variant-picker[data-artsy-valid-options]';
const photos = new Map();
const limit = 24;

function optionFrom(event) {
  const target = event.target;
  if (!(target instanceof Element)) return;
  if (target.matches('select')) return target.selectedOptions[0];
  return target.closest('[data-artsy-color-preview]') ||
    target.closest('label')?.querySelector('input[data-artsy-color-preview]');
}

function warm(event) {
  const option = optionFrom(event);
  const picker = option?.closest(pickerSelector);
  if (!picker || option.dataset.optionAvailable !== 'true') return;
  const selected = [...picker.querySelectorAll('input[type="radio"]:checked, select option:checked')]
    .map((input) => input.dataset.optionValueId);
  const context = option.dataset.artsyPreviewContext?.split(',').filter(Boolean);
  // Reject stale Color metadata during an outstanding Style/Size update.
  if (!context?.length || !context.every((id) => selected.includes(id))) return;
  const connection = navigator.connection;
  if (event.type !== 'change' && (connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || ''))) return;
  const gallery = picker.closest('.shopify-section')?.querySelector('media-gallery');
  const current = gallery?.querySelector('.product-media__image');
  if (!current) return;
  const template = document.createElement('template');
  template.innerHTML = option.dataset.artsyColorPreview || '';
  const source = template.content.querySelector('img');
  if (!source?.getAttribute('src')) return;
  const sizes = current.getAttribute('sizes') || `${Math.ceil(current.getBoundingClientRect().width)}px`;
  const src = source.getAttribute('src');
  const srcset = source.getAttribute('srcset') || '';
  const key = JSON.stringify([picker.dataset.productId, sizes, src, srcset]);
  if (photos.has(key)) {
    const photo = photos.get(key);
    if (event.type === 'change') photo.fetchPriority = 'high';
    photos.delete(key); photos.set(key, photo);
    return;
  }
  const photo = new Image();
  photo.decoding = 'async';
  photo.fetchPriority = event.type === 'change' ? 'high' : 'low';
  photos.set(key, photo);
  while (photos.size > limit) photos.delete(photos.keys().next().value);
  photo.addEventListener('error', () => { if (photos.get(key) === photo) photos.delete(key); }, { once: true });
  // Match the native gallery's responsive choice, avoiding a full-size fallback download.
  photo.sizes = sizes;
  if (srcset) photo.srcset = srcset;
  photo.src = src;
}

document.addEventListener('pointerover', warm, true);
document.addEventListener('focusin', warm, true);
// Capture runs before the existing picker starts its ordinary section fetch.
document.addEventListener('change', warm, true);
